var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0377 5.82404L10.6867 6.98704C11.2717 8.03704 11.0367 9.41304 10.1147 10.336C10.1147 10.336 8.99466 11.455 11.0247 13.484C13.0517 15.511 14.1717 14.394 14.1717 14.394C15.0947 13.471 16.4717 13.236 17.5207 13.821L18.6837 14.471C20.2687 15.355 20.4557 17.577 19.0627 18.971C18.2257 19.807 17.1997 20.459 16.0667 20.501C14.1587 20.574 10.9177 20.091 7.66666 16.841C4.41666 13.59 3.93366 10.349 4.00666 8.44104C4.04966 7.30804 4.70066 6.28204 5.53666 5.44504C6.93066 4.05204 9.15266 4.23904 10.0367 5.82504L10.0377 5.82404Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.8ae43478844a29b2d77258e78052f7a0.svg";
export { ForwardRef as ReactComponent };